export default __webpack_public_path__ + "static/media/Dead Sea Scrolls - All Souls Deuteronomy_05.30d08118.jpg";